import { isNumber, size } from 'lodash';

String.prototype.capitalize = function (locales) {
    return this.charAt(0).toLocaleUpperCase(locales) + this.slice(1);
};

export class LaravelFormatter {
    constructor(locales) {
        this.locales = locales;
    }

    // noinspection JSUnusedGlobalSymbols
    interpolate(message, values) {
        // Nothing to interpolate
        if (values === null) return message;

        // Get the relevant translation choice if applicable
        const input = LaravelFormatter.isTranslationChoice(message, values)
            ? LaravelFormatter.chooseTranslation(message, values)
            : message;

        // Run through all the values and replace the placeholders based on the value's key
        return Object.entries(values).reduce(
            (result, [key, value]) => this.replacePlaceholder(result, key, value),
            input,
        );
    }

    /**
     * @param message {string}
     * @param key {string}
     * @param value {any}
     * @return {string}
     */
    replacePlaceholder(message, key, value) {
        value ??= '';

        return message
            .replaceAll(':' + key.capitalize(this.locales), value.toString().capitalize(this.locales))
            .replaceAll(':' + key.toLocaleUpperCase(this.locales), value.toString().toLocaleUpperCase(this.locales))
            .replaceAll(':' + key, value.toString());
    }

    /**
     * @param message {string}
     * @param values {Object}
     * @return {boolean}
     */
    static isTranslationChoice(message, values) {
        return values !== null && values.hasOwnProperty('count') && values.hasOwnProperty('n') && message.includes('|');
    }

    /**
     * @param message {string}
     * @param values {Object}
     * @return {string}
     */
    static chooseTranslation(message, values) {
        // If the count is a number, use it directly, otherwise use the size of the array/object
        const count = isNumber(values['count']) ? values['count'] : size(values['count']);

        // Split the message into the different options
        const options = message.split('|');

        // Matches strings that start with `{n}` or `[n,n]` or `[n,*]`, followed by an optional space and then the translation
        const regex = /^(?:\{(?<single>\d+)}|\[(?<start>\d+),(?<endInclusive>\d+|\*)]) ?(?<translation>[^|]+?)$/;

        let matchGroup = options
            // Get the plurality definitions (e.g. `{1}` or `[2,*]`) with their corresponding translation
            .map((option) => option.match(regex)?.groups)
            // Find the first match that fits the count
            .find((matchGroups) => {
                if (!matchGroups) return false;

                const single = matchGroups['single'] ? parseInt(matchGroups['single']) : null;
                if (single !== null) return count === single;

                const start = matchGroups['start'] ? parseInt(matchGroups['start']) : null;
                const endInclusive = matchGroups['endInclusive'] ? parseInt(matchGroups['endInclusive']) : null;

                if (isNaN(endInclusive)) return count >= start;
                return count >= start && count <= endInclusive;
            });

        // There are no plurality definitions, so we there must be two options: the first for singular and second for plural
        if (!matchGroup) {
            if (options.length !== 2) throw new Error(`Expected two choices or ranges in translation: "${message}"`);
            return count === -1 || count === 1 ? options[0] : options[1];
        }

        // Return the option that fits the count
        if (!matchGroup['translation']) throw new Error(`No translation choice found for range: "${message}"`);
        return matchGroup['translation'];
    }
}
